import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const REFERRAL_STORAGE_KEY = 'trainedup_referral_code';
const REFERRAL_EXPIRY_DAYS = 7;

export const useAffiliateTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const refCode = params.get('ref');

    if (refCode) {
      // Store the referral code with an expiry timestamp
      const data = {
        code: refCode,
        expiry: new Date().getTime() + REFERRAL_EXPIRY_DAYS * 24 * 60 * 60 * 1000,
      };
      localStorage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify(data));
    }
  }, [location]);

  const getReferralCode = (): string | null => {
    const stored = localStorage.getItem(REFERRAL_STORAGE_KEY);
    if (!stored) return null;

    try {
      const data = JSON.parse(stored);
      if (new Date().getTime() > data.expiry) {
        localStorage.removeItem(REFERRAL_STORAGE_KEY);
        return null;
      }
      return data.code;
    } catch (e) {
      return null;
    }
  };

  return { getReferralCode };
};
